const blankToNull = require('./../../../utils').blankToNull;

export function validate(record){
    blankToNull(record);
    return Promise.resolve({record})
}